import React from 'react';
import BordasPorTamanho from '../BordasPorTamanho';
import { Table } from 'rsuite';
import RModal from '../../../components/Rsuite/Modal';
import { NotificationManager } from 'react-notifications';
import { CustomButton } from '../../../components/CustomButton';
import { CustomCheckPicker } from '../../../components/CustomCheckPicker';
import { CustomCell } from '../../../components/CustomCell';
import { CustomHeaderCell } from '../../../components/CustomHeaderCell';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { useMountingProducts } from './useMountingProducts';
import * as S from './styles';
import { Spacer } from '../../../components/Spacer';

const { Column } = Table;

const ProdutosMontagem = ({ modal, close, montagem, produtos, config }) => {
  const { theme } = useCustomTheme();
  const {
    montagemProdutos,
    idProdutos,
    modalBorda,
    setMontagemProdutos,
    setIdProdutos,
    setModalBorda,
    addProduto,
    alterarStatus,
    deletarProduto,
  } = useMountingProducts({
    montagem,
    modal,
  });

  return (
    <RModal
      open={modal}
      onClose={close}
      title={
        montagem
          ? `Editar Produtos da Montagem`
          : 'Cadastrar Produtos da Montagem'
      }
      bodyStyle={{ width: '924px' }}
      footer={
        <>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <S.Content>
        <S.InputWrapper>
          <CustomCheckPicker
            placeholder="Selecione os produtos para a montagem"
            data={produtos}
            value={idProdutos}
            onChange={setIdProdutos}
            style={{
              flexGrow: '1',
              maxWidth: '90%',
            }}
          />

          <Spacer x={10} />

          <CustomButton onClick={addProduto} appearance="primary">
            Alterar
          </CustomButton>
        </S.InputWrapper>

        <Spacer y={20} />

        <S.StyledTable
          height={260}
          data={montagemProdutos}
          locale={{
            emptyMessage: 'Nenhuma montagem encontrada',
            loading: 'Carregando...',
          }}
        >
          <Column align="center" width={104}>
            <CustomHeaderCell>Código</CustomHeaderCell>
            <CustomCell dataKey="Id" />
          </Column>

          <Column width={104}>
            <CustomHeaderCell>IdProduto</CustomHeaderCell>
            <CustomCell dataKey="IdProduto" />
          </Column>

          <Column width={104}>
            <CustomHeaderCell>Codigo PDV</CustomHeaderCell>
            <CustomCell dataKey="CodigoPDV" />
          </Column>

          <Column width={270}>
            <CustomHeaderCell>Descricao</CustomHeaderCell>
            <CustomCell dataKey="Descricao" />
          </Column>

          <Column width={80}>
            <CustomHeaderCell>Disponível</CustomHeaderCell>
            <CustomCell dataKey="Disponivel">
              {(rowData) => (
                <S.AvalilableText available={rowData.Disponivel}>
                  {rowData.Disponivel ? 'Sim' : 'Não'}
                </S.AvalilableText>
              )}
            </CustomCell>
          </Column>
          <Column width={104}>
            <CustomHeaderCell>Ativo</CustomHeaderCell>
            <CustomCell dataKey="Fim">
              {(rowData) => {
                const buttonStyle = {
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  width: 50,
                };
                const isFinished = rowData.Ativo;
                const appearance = isFinished ? 'ghost' : 'primary';
                const text = isFinished ? 'Sim' : 'Não';

                return (
                  <span style={{ padding: 0 }}>
                    <CustomButton
                      appearance={appearance}
                      style={buttonStyle}
                      onClick={() => alterarStatus(!isFinished, rowData.Id)}
                    >
                      {text}
                    </CustomButton>
                  </span>
                );
              }}
            </CustomCell>
          </Column>

          <Column width={154}>
            <CustomHeaderCell>Opções</CustomHeaderCell>
            <CustomCell>
              {(rowData) => (
                <>
                  <span>
                    <CustomButton
                      appearance="ghost"
                      color={theme.colors.warning}
                      onClick={() => {
                        deletarProduto(rowData.Id);
                      }}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 4px',
                      }}
                    >
                      Excluir
                    </CustomButton>
                  </span>
                </>
              )}
            </CustomCell>
          </Column>
        </S.StyledTable>

        {modalBorda && (
          <BordasPorTamanho
            modal={modalBorda}
            fecharModal={() => setModalBorda(false)}
            setMontagemProdutos={setMontagemProdutos}
            NotificationManager={NotificationManager}
            config={config}
          />
        )}
      </S.Content>
    </RModal>
  );
};

export default ProdutosMontagem;
